import '../scss/main.scss';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

import Anchor from './Anchor';
import Dropdown from './Dropdown';
import Menu from './Menu';
import FormOverlay from './FormOverlay';
import VideoOverlay from './VideoOverlay';

import SectionOrderRenderer from './SectionOrderRenderer';
import DataFetcher from './DataFetcher';
import PickupRenderer from './PickupRenderer';
import ProgramRenderer from './ProgramRenderer';
import ProductRenderer from './ProductRenderer';

import AnimationController from './AnimationController';

gsap.registerPlugin(ScrollTrigger);

class App {
  constructor() {
    this.win = {
      width: window.innerWidth,
      height: window.innerHeight,
      aspectRatio: window.innerWidth / window.innerHeight,
      isMobile: window.innerWidth <= 767
    };
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('DOMContentLoaded', this.onDocReady.bind(this));
    window.onload = () => this.onWindowLoad();
  }

  onDocReady() {
    this.initDataFetcher();

    this.initMenu();
    this.initFormOverlay();
    this.initVideoOverlay();
    this.initAnchors();

    this.initSectionOrderRenderer();

    this.initPickupRenderer();
    this.initProgramRenderer();
    this.initProductRenderer();
  }

  onWindowLoad() {
    document.body.classList.remove('is-loading');
    this.initDropdowns();

    if (document.body.classList.contains('page-index')) {
      AnimationController.initAll();
    }
  }

  initMenu() {
    const menu = new Menu();
    menu.init();
  }

  initAnchors() {
    const anchorEls = document.querySelectorAll('[data-anchor="el"]');
    anchorEls.forEach(el => new Anchor(el));
  }

  initDropdowns() {
    setTimeout(() => {
      const qaList = document.querySelectorAll('.qa [data-dropdown="el"]');
      const archiveList = document.querySelectorAll('.archive [data-dropdown="el"]');

      qaList.forEach(el => {
        const dropdown = new Dropdown({
          el: el,
          headEl: el.querySelectorAll('.dropdown__head'),
          bodyEl: el.querySelector('.dropdown__body')
        })

        dropdown.init();
      });

      archiveList.forEach(el => {
        const dropdown = new Dropdown({
          el: el,
          headEl: el.querySelectorAll('.archive__more a'),
          bodyEl: el.querySelector('.archive__body')
        })

        dropdown.init();
      });
    }, 1);
  }

  initVideoOverlay() {
    const videoOverlay = new VideoOverlay();
    videoOverlay.init();
  }

  initFormOverlay() {
    const formOverlay = new FormOverlay();
    formOverlay.init();
  }

  initDataFetcher() {
    const dataFetcher = new DataFetcher({
      dataUrl: `/special/groundbreakers/assets/data/gb_web_json.json`
    });
    dataFetcher.init();
  }

  initSectionOrderRenderer() {
    const sectionOrderRenderer = new SectionOrderRenderer();
    sectionOrderRenderer.init();
  }

  initPickupRenderer() {
    const pickupRenderer = new PickupRenderer();
    pickupRenderer.init();
  }

  initProgramRenderer() {
    const programRenderer = new ProgramRenderer();
    programRenderer.init();
  }

  initProductRenderer() {
    const productRenderer = new ProductRenderer();
    productRenderer.init();
  }
}

const app = new App();
app.init();